<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.7601 20.5959L17.3313 16.1671C18.6143 14.6195 19.3129 12.6921 19.3129 10.6576C19.314 8.34562 18.4132 6.17122 16.7786 4.5366C15.144 2.90198 12.9684 2 10.6564 2C8.34445 2 6.17005 2.90081 4.53543 4.53543C2.90081 6.17005 2 8.34445 2 10.6564C2 12.9684 2.90081 15.1416 4.53543 16.7774C6.17005 18.4121 8.34327 19.3117 10.6553 19.3117H10.6564C12.6921 19.3117 14.6183 18.612 16.1659 17.3302L20.5947 21.7589C20.7558 21.92 20.9663 22 21.1768 22C21.3873 22 21.5978 21.92 21.7589 21.7589C22.0811 21.4379 22.0811 20.9169 21.7601 20.5959ZM10.6564 17.6665C10.6553 17.6665 10.6553 17.6665 10.6564 17.6665C8.78427 17.6665 7.02381 16.9374 5.70083 15.6132C4.37549 14.2891 3.64638 12.5298 3.64638 10.6564C3.64638 8.78309 4.37549 7.02381 5.70083 5.69965C7.02381 4.37667 8.78427 3.64638 10.6564 3.64638C12.5286 3.64638 14.2891 4.37549 15.6132 5.69965C16.9374 7.02264 17.6665 8.78427 17.6665 10.6564C17.6653 12.5286 16.9362 14.2891 15.612 15.612C14.2879 16.9362 12.5286 17.6653 10.6564 17.6665Z"
      :fill="iconColor"
    />
  </svg>
</template>

<script>
export default {
  name: "IconSearch",
  data: () => ({
    iconColor: "currentColor",
  }),
};
</script>
